import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<void>()((theme) => ({
	buttonWrapper: {
		display: 'grid',
		gap: theme.spacing.xsmall,
		gridTemplateColumns: 'repeat(2, max-content)',
		justifyContent: 'center',
		paddingBottom: theme.spacing.small,

		'& > button': {
			textWrap: 'nowrap',
		},
	},
}));
